/** @jsxImportSource theme-ui */

const StaffingNO = () => (
  <iframe
    sx={{ flex: "auto" }}
    src="https://staffing.adbj.no/event/163"
    sandbox="allow-scripts"
  ></iframe>
)

export { StaffingNO }
